import {
  convertToDateTimeFilters,
  useDateTimeFilter,
  useDateTimePickerContext,
} from '~/presentation/ui';
import { useCampaignMaps } from '~/modules/campaign-template';
import { getVersionsByCampaignGroup } from '../utils';
import { dayjs } from '~/utils/dayjs';

export const useResetDatepickerByCampaign = () => {
  const { campaignGroupMap } = useCampaignMaps();
  const { setDateTimePicked, dateTimePicked } = useDateTimePickerContext();
  const { DATE_TIME_FILTERS } = useDateTimeFilter();

  const resetDatepicker = (campaignIds: string[], campaignGroupId?: string) => {
    if (!campaignGroupId || dateTimePicked.alias === 'custom') return;

    const isInDateTimeFilter = DATE_TIME_FILTERS.some(
      (filter) => filter.alias === dateTimePicked.alias,
    );
    if (isInDateTimeFilter) return;

    const versions = getVersionsByCampaignGroup({
      campaignIds,
      campaignGroupId,
      campaignGroupMap,
    });

    const dateRangesByVersion = convertToDateTimeFilters(versions);

    const dateRangeByVersion = dateRangesByVersion.find(
      (range) => range.until === dateTimePicked.until && range.since === dateTimePicked.since,
    );

    if (dateRangeByVersion) {
      setDateTimePicked({
        ...dateTimePicked,
        alias: dateRangeByVersion.alias,
        title: dateRangeByVersion.title,
      });
      return;
    }

    setDateTimePicked({
      ...dateTimePicked,
      since: dayjs(dateTimePicked.since).startOf('day').valueOf(),
      until: dayjs(dateTimePicked.until).endOf('day').valueOf(),
      alias: 'custom',
      title: 'Custom',
    });
  };

  return { resetDatepicker };
};
